module.exports = "<p>\n  buy-now-button-click works!\n</p>\n"